export class SiteJuridiction {
    constructor(
        public id: number,
        public libelleCourt: string,
        public libelleLong: string,
        public code: string
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/site-juridiction/site-juridiction.model.ts